window.BlockTalent = () => {
    return {
        // eslint-disable-next-line no-undef
        ajax_url: ajax_object.ajax_url,
        page: 1,
        talent: [],
        types: [],
        locations: [],
        activeType: null,
        activeLocation: null,
        initTalent() {
            this.setActiveType(null);
            this.setActiveLocation(null);
            this.getTalent();
        },
        resetTalent() {
            this.page = 1;
            this.talent = [];
        },
        addType(id, slug, name) {
            this.types.push({ 
                id: parseInt(id), 
                slug: slug, 
                name: name, 
                el: document.querySelector('a.talent-type[data-slug='+slug+']'),
            });
        },
        addLocation(id, slug, name) {
            this.locations.push({ 
                id: parseInt(id), 
                slug: slug, 
                name: name, 
                el: document.querySelector('a.talent-location[data-slug='+slug+']'),
             });
        },
        removeCurrentlyActiveType() {
            let currentlyActive = document.querySelector('a.talent-type.active');
            if(currentlyActive !== null) {
                currentlyActive.classList.remove('active');
            }
        },
        removeCurrentlyActiveLocation() {
            let currentlyActive = document.querySelector('a.talent-location.active');
            if(currentlyActive !== null) {
                currentlyActive.classList.remove('active');
            }
        },
        setActiveType(slug) {
            this.removeCurrentlyActiveType();
            this.resetTalent();
            /* eslint-disable */
            if(slug == null) {
                var el = document.querySelector('a.talent-type');
            } else {
                var el = document.querySelector('a.talent-type[data-slug='+slug+']');
            }
            this.activeType = {
                id: el.dataset.id,
                slug: el.dataset.slug,
                name: el.dataset.name,
                el: el,
            };
            /* eslint-enable */

            this.activeType.el.classList.add('active');
            if(this.activeType !== null && this.activeLocation !== null) {
                this.resetTalent();
                this.getTalent();
            }
        },
        setActiveLocation(slug) {
            this.removeCurrentlyActiveLocation();
            /* eslint-disable */
            if(slug == null) {
                var el = document.querySelector('a.talent-location');
            } else {
                var el = document.querySelector('a.talent-location[data-slug='+slug+']');
            }
            this.activeLocation = {
                id: el.dataset.id,
                slug: el.dataset.slug,
                name: el.dataset.name,
                el: el,
            };
            /* eslint-enable */

            this.activeLocation.el.classList.add('active');
            if(this.activeType !== null && this.activeLocation !== null) {
                this.resetTalent();
                this.getTalent();
            }
        },
        getTalent() {
            
            fetch(this.ajax_url, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: new URLSearchParams({
                    action: 'get_talent',
                    paged: this.page,
                    type: this.activeType.id,
                    location: this.activeLocation.id,
                }),
            }).then((response) => response.json())
                .then((data) => {
                    this.talent = this.talent.concat(data);
                })
                .catch((error) => console.log(error));
            
            this.page++;
        },
    }
}



// WEBPACK FOOTER //
// ./scripts/blocks/Talent.js